module.exports = __webpack_public_path__ + "static/media/TotalCuenta.bb80adc3.svg";